webpackJsonp([210827194941791],{

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"], ["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"], ["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"], ["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    padding-top: 0;\n    display:block;\n  "], ["\n    padding-top: 0;\n    display:block;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"], ["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"], ["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n   position: relative;\n   flex-basis: 100%;\n   text-align: left;\n   font-size: 1.4rem;\n   background: transparent;\n   color: ", ";\n   text-decoration: underline;\n   cursor: pointer;\n   margin-top: ", "rem;\n   transition: margin-left .3s;\n   &:hover {\n      margin-left: 1rem;\n   }\n   &:before {\n      content: \"\";\n      display: inline-block;\n      width: 3rem;\n      height: 3rem;\n      background: url(", ");\n      vertical-align: middle;\n      margin-right: ", "px;\n   }\n"], ["\n   position: relative;\n   flex-basis: 100%;\n   text-align: left;\n   font-size: 1.4rem;\n   background: transparent;\n   color: ", ";\n   text-decoration: underline;\n   cursor: pointer;\n   margin-top: ", "rem;\n   transition: margin-left .3s;\n   &:hover {\n      margin-left: 1rem;\n   }\n   &:before {\n      content: \"\";\n      display: inline-block;\n      width: 3rem;\n      height: 3rem;\n      background: url(", ");\n      vertical-align: middle;\n      margin-right: ", "px;\n   }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"], ["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"], ["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"], ["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"], ["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"], ["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(45);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _input = __webpack_require__(23);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _rightCircleWhite = __webpack_require__(20);
	
	var _rightCircleWhite2 = _interopRequireDefault(_rightCircleWhite);
	
	var _autofill = __webpack_require__(37);
	
	var _autofill2 = _interopRequireDefault(_autofill);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = {
	   color: _vars.colors.inactiveColor,
	   backgroundColor: "transparent",
	   paddingLeft: "1rem",
	   fontSize: "1.5rem"
	};
	
	var RegisterForm = function (_React$Component) {
	   _inherits(RegisterForm, _React$Component);
	
	   function RegisterForm() {
	      _classCallCheck(this, RegisterForm);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	      var url = void 0;
	      if (typeof window !== "undefined") {
	         url = window.location.href.replace("https://", "").replace("http://", "").replace(/\/$/, "");
	      } else {
	         url = "";
	      }
	      _this.state = {
	         formStatus: "incomplete",
	         values: {},
	         url: url
	      };
	      return _this;
	   }
	
	   RegisterForm.prototype.updateForm = function updateForm(e) {
	      var values = this.state.values;
	      if (e.target.getAttribute("name") !== "Postcode") {
	         values[e.target.getAttribute("name")] = e.target.value;
	         this.setState({ values: values });
	      } else {
	         return false;
	      }
	   };
	
	   RegisterForm.prototype.componentDidMount = function componentDidMount() {
	      this.updateForm = this.updateForm.bind(this);
	      this.handleSubmit = this.handleSubmit.bind(this);
	   };
	
	   RegisterForm.prototype.handleSubmit = function handleSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      var submitBtn = document.getElementById("submit");
	      submitBtn.style.cursor = "progress";
	      submitBtn.disabled = true;
	      submitBtn.innerHTML = 'LOADING';
	
	      var fields = [].slice.call(e.target.querySelectorAll("[name]"));
	      fields.map(function (f) {
	         var values = _this2.state.values;
	         values[f.getAttribute("name")] = f.value;
	      });
	
	      var values = this.state.values;
	
	      values['comment'] = "Booking Requested\n\n\t\t\t" + values.Prefered_Date + "\n\n\t\t\t" + values.Prefered_Time + "\n\n         ";
	
	      if (values['tags']) {
	         values['interested_in'] = values['tags'];
	      }
	
	      values['tags'] = [];
	      if (values['interested_in']) {
	         values['tags'].push(decodeURI(values['interested_in']));
	      }
	
	      if (values['tags_2']) {
	         values['tags'].push(decodeURI(values['tags_2']));
	      }
	      if (values['tags_3']) {
	         values['tags'].push(decodeURI(values['tags_3']));
	      }
	      if (values['tags_4']) {
	         values['tags'].push(decodeURI(values['tags_4']));
	      }
	
	      values['suburb'] = values.suburb.trim();
	      values['postcode'] = '0000';
	      values['state'] = 'NA';
	      if (values['suburb'] !== 'Outside Australia') {
	         values['postcode'] = values.suburb.substr(values.suburb.length - 4);
	         values['suburb'] = values.suburb.slice(0, -4);
	         values['suburb'] = values.suburb.trim().replace(",", "");
	         values['state'] = values.suburb.substr(values.suburb.length - 3).trim();
	         values['suburb'] = values.suburb.slice(0, -3).trim();
	      }
	
	      // submitToInsite(values).then(function(){
	      fetch("https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/yarrabend-v4", {
	         method: "POST",
	         headers: { "Content-Type": "application/json" },
	         body: JSON.stringify(values)
	      }).then(function (res) {
	         return res.json();
	      }).then(function (json) {
	         if (json.errorMessage) {
	            alert('Error submitting request please call +61 (0)3 9573 8320');
	         } else {
	            var formStatus = "complete";
	            _this2.setState({ formStatus: formStatus });
	         }
	      }).catch(function (err) {
	         return console.log(err);
	      });
	      // }.bind(this))
	   };
	
	   RegisterForm.prototype.render = function render() {
	
	      var project_name = '';
	
	      // if(this.props.utm.utm_campaign){
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("artisan-residences")){
	      //       project_name = 'Artisan Residences';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("culinary-house")){
	      //       project_name = 'Culinary House';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("fourdrinier-house")){
	      //       project_name = 'Fourdrinier House';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("sheahan-townhouses")){
	      //       project_name = 'Sheahan Townhouses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("camber-lofts")){
	      //       project_name = 'Camber lofts';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("papersmith")){
	      //       project_name = 'Papersmith';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("PVA")){
	      //       project_name = 'Parkview Apartments';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Parkview-houses")){
	      //       project_name = 'Parkview Houses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Parkview-townhouses")){
	      //       project_name = 'Parkview Townhouses';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-41")){
	      //       project_name = 'The Mills 4.1';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-42")){
	      //       project_name = 'The Mills 4.2';
	      //    }else
	      //    if(this.props.utm.utm_campaign.toLowerCase().includes("Mills-43")){
	      //       project_name = 'The Mills 4.3';
	      //    }
	      // }
	
	      function prettify(str) {
	         return str.split('-').map(function capitalize(part) {
	            return part.charAt(0).toUpperCase() + part.slice(1);
	         }).join(' ');
	      }
	
	      if (this.props.property) {
	         if (this.props.property === "papersmith-apartments") {
	            project_name = "Papersmith";
	         } else if (this.props.property === "sheahan-townhouses") {
	            project_name = "Sheahan Townhouses";
	         } else if (this.props.property === "artisan-residences") {
	            project_name = "Artisan Residences";
	         } else if (this.props.property === "parkview-houses") {
	            project_name = "Parkview Houses";
	         } else if (this.props.property === "parkview-apartments-2") {
	            project_name = "Parkview Apartments";
	         } else if (this.props.property === "parkview-apartments") {
	            project_name = "Parkview Apartments";
	         } else if (this.props.property === "artisan--culinary-house") {
	            project_name = "Culinary House";
	         } else if (this.props.property === "parkview-townhouses") {
	            project_name = "Parkview Townhouses";
	         } else if (this.props.property === "the-mills-lofts") {
	            project_name = "The Mills 4.1";
	         } else if (this.props.property === "the-mills-townhouses") {
	            project_name = "The Mills 4.2";
	         } else if (this.props.property === "fourdrinier-house") {
	            project_name = "Fourdrinier House";
	         } else if (this.props.property === "completed-homes") {
	            project_name = "Completed Homes";
	         } else if (this.props.property === "seren-row") {
	            project_name = "Outer Circle";
	         } else {
	            project_name = prettify(this.props.property);
	         }
	      }
	
	      return _react2.default.createElement(
	         Container,
	         { popup: this.props.popup, shown: this.props.shown },
	         this.props.popup && _react2.default.createElement(Close, { onClick: this.props.toggleForm }),
	         this.state.formStatus === "complete" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	               Heading,
	               null,
	               "THANK YOU FOR REQUESTING A BOOKING"
	            ),
	            _react2.default.createElement(
	               ThankYouText,
	               { className: 'form__thankyou' },
	               "A member of the YarraBend team will be in contact with you shortly."
	            )
	         ) : _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: theme },
	            _react2.default.createElement(
	               Form,
	               { action: "", onSubmit: this.handleSubmit },
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_input2.default, {
	                     name: "first_name",
	                     label: "First Name",
	                     required: true,
	                     onChange: this.updateForm
	                  })
	               ),
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_input2.default, {
	                     name: "last_name",
	                     label: "Surname",
	                     required: true,
	                     onChange: this.updateForm
	                  })
	               ),
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_input2.default, {
	                     name: "phone",
	                     label: "Phone Number",
	                     required: true,
	                     onChange: this.updateForm
	                  })
	               ),
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_autofill2.default, null)
	               ),
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_input2.default, {
	                     name: "email",
	                     label: "Email address",
	                     required: true,
	                     onChange: this.updateForm
	                  })
	               ),
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_input2.default, {
	                     name: "tags",
	                     type: "select",
	                     label: "Home Type",
	                     onChange: this.updateForm,
	                     required: true,
	                     options: [{ value: "All", label: "All" }, { value: "Lofts", label: "Lofts" }, { value: "Apartments", label: "Apartments" }, { value: "Townhouse", label: "Townhouse" }]
	                  })
	               ),
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_input2.default, {
	                     name: "Prefered_Date",
	                     type: "select",
	                     label: "Prefered Date",
	                     onChange: this.updateForm,
	                     required: true,
	                     options: [{ value: "mon", label: "Monday" }, { value: "tue", label: "Tuesday" }, { value: "wed", label: "Wednesday" }, { value: "thu", label: "Thursday" }, { value: "fri", label: "Friday" }, { value: "sat", label: "Saturday" }, { value: "sun", label: "Sunday" }]
	                  })
	               ),
	               _react2.default.createElement(
	                  Field,
	                  null,
	                  _react2.default.createElement(_input2.default, {
	                     name: "Prefered_Time",
	                     type: "select",
	                     label: "Prefered Time",
	                     onChange: this.updateForm,
	                     required: true,
	                     options: [{ value: "Morning", label: "Morning" }, { value: "Afternoon", label: "Afternoon" }, { value: "Evening", label: "Evening" }]
	                  })
	               ),
	               _react2.default.createElement("input", { type: "hidden", id: "utm_source", name: "tags_2", value: this.props.utm.utm_source }),
	               _react2.default.createElement("input", { type: "hidden", id: "utm_medium", name: "tags_3", value: this.props.utm.utm_medium }),
	               _react2.default.createElement("input", { type: "hidden", id: "utm_campaign", name: "tags_4", value: this.props.utm.utm_campaign }),
	               _react2.default.createElement("input", { type: "hidden", id: "referrer", name: "referrer", value: this.props.utm.referrer }),
	               _react2.default.createElement("input", { type: "hidden", id: "project_name", name: "project_name", value: project_name }),
	               _react2.default.createElement("input", { type: "hidden", id: "property", name: "property", value: this.props.property }),
	               this.props.square ? _react2.default.createElement(
	                  "button",
	                  { id: "submit", className: "btn btn-square" },
	                  _react2.default.createElement(
	                     "span",
	                     null,
	                     "Request an appointment"
	                  )
	               ) : _react2.default.createElement(
	                  Submit,
	                  { id: "submit", square: this.props.square },
	                  "Request an appointment"
	               )
	            )
	         )
	      );
	   };
	
	   return RegisterForm;
	}(_react2.default.Component);
	
	exports.default = RegisterForm;
	
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Close = _styledComponents2.default.div(_templateObject2, _vars.colors.blank, vars.time);
	
	var Form = _styledComponents2.default.form(_templateObject3, vars.padding.inner, _functions.below.tablet(_templateObject4), _functions.below.mobile(_templateObject5));
	
	var Field = _styledComponents2.default.div(_templateObject6, _vars.colors.inactiveColor, _functions.below.mobile(_templateObject7));
	
	var Submit = _styledComponents2.default.button(_templateObject8, _vars.colors.blank, vars.padding.inner / 2, _rightCircleWhite2.default, vars.padding.mobOuter * 2);
	
	var Heading = _styledComponents2.default.p(_templateObject9, _vars.colors.brandHighlight);
	
	var ThankYouText = _styledComponents2.default.p(_templateObject10, _vars.colors.white);
	
	var FormNote = _styledComponents2.default.p(_templateObject11, _vars.colors.brandHighlight);
	
	var Logo = _styledComponents2.default.img(_templateObject12);
	var FormError = _styledComponents2.default.p(_templateObject13);
	module.exports = exports["default"];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n   background: bottom/cover no-repeat url('/images/display.jpg');\n   height: 100vmin;\n   min-height: 90rem;\n   padding: ", "rem;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   position: relative;\n   ", " ", "\n\t &:after {\n      content: \"\";\n      display: block;\n      background: radial-gradient(rgba(255, 255, 255, 0) 40%, rgba(63, 62, 62, 0) 60%);\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      z-index: 2;\n   }\n"], ["\n   background: bottom/cover no-repeat url('/images/display.jpg');\n   height: 100vmin;\n   min-height: 90rem;\n   padding: ", "rem;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   position: relative;\n   ", " ", "\n\t &:after {\n      content: \"\";\n      display: block;\n      background: radial-gradient(rgba(255, 255, 255, 0) 40%, rgba(63, 62, 62, 0) 60%);\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      z-index: 2;\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\t padding: ", "rem;\n\t "], ["\n\t padding: ", "rem;\n\t "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n\t padding: ", "rem;\n\t min-height: 70rem;\n\n\t "], ["\n\t padding: ", "rem;\n\t min-height: 70rem;\n\n\t "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n   text-align: center;\n   padding: ", "rem ", "rem;\n   max-width: 90rem;\n   background: rgba(255, 255, 255, 0.95);\n   position: relative;\n   z-index: 4;\n   ", " ", "\n\n   h2 {\n      padding-bottom: 5rem;\n      ", " ", ";\n   }\n\n   h4 {\n      margin: 0 auto;\n      max-width: 60rem;\n   }\n\n   form {\n      margin: 0 auto;\n      text-align: left;\n\n      button {\n         color: ", ";\n         font-size: 1.5rem;\n         margin-top: 4rem;\n      }\n   }\n\n   .close-button {\n      position: absolute;\n      display: block;\n      top: 1rem;\n      right: 1rem;\n      height: 25px;\n      width: 25px;\n      cursor: pointer;\n\n      &:before {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px;\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(45deg);\n      }\n\n      &:after {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(-45deg);\n         cursor: pointer;\n      }\n   }\n\n"], ["\n   text-align: center;\n   padding: ", "rem ", "rem;\n   max-width: 90rem;\n   background: rgba(255, 255, 255, 0.95);\n   position: relative;\n   z-index: 4;\n   ", " ", "\n\n   h2 {\n      padding-bottom: 5rem;\n      ", " ", ";\n   }\n\n   h4 {\n      margin: 0 auto;\n      max-width: 60rem;\n   }\n\n   form {\n      margin: 0 auto;\n      text-align: left;\n\n      button {\n         color: ", ";\n         font-size: 1.5rem;\n         margin-top: 4rem;\n      }\n   }\n\n   .close-button {\n      position: absolute;\n      display: block;\n      top: 1rem;\n      right: 1rem;\n      height: 25px;\n      width: 25px;\n      cursor: pointer;\n\n      &:before {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px;\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(45deg);\n      }\n\n      &:after {\n         content: \"\";\n         position: absolute;\n         display: block;\n         height: 1px;\n         width: 25px\n         top: 12px;\n         right: 0;\n         background-color: rgb(25, 25, 25);\n         transform: rotate(-45deg);\n         cursor: pointer;\n      }\n   }\n\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose([";\n      margin-top: 6rem;\n\t\t\tpadding: ", "rem;\n   "], [";\n      margin-top: 6rem;\n\t\t\tpadding: ", "rem;\n   "]),
	    _templateObject6 = _taggedTemplateLiteralLoose([";\n      margin-top: 4rem;\n\t\t\tpadding: ", "rem ", "rem;\n   "], [";\n      margin-top: 4rem;\n\t\t\tpadding: ", "rem ", "rem;\n   "]),
	    _templateObject7 = _taggedTemplateLiteralLoose([";\n\t\t\tpadding-bottom: ", "rem;\n   "], [";\n\t\t\tpadding-bottom: ", "rem;\n   "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _functions = __webpack_require__(6);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _bookForm = __webpack_require__(306);
	
	var _bookForm2 = _interopRequireDefault(_bookForm);
	
	var _header = __webpack_require__(21);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Enquiry = function (_React$Component) {
	   _inherits(Enquiry, _React$Component);
	
	   function Enquiry() {
	      _classCallCheck(this, Enquiry);
	
	      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	   }
	
	   Enquiry.prototype.componentWillMount = function componentWillMount() {
	      this.props.updateMeta("Enquire Now | YarraBend", "Enquire about yarrabend and one of our team will get back to you.");
	      this.props.updatePageType(null);
	   };
	
	   Enquiry.prototype.render = function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          router = _props.router,
	          params = _props.params,
	          location = _props.location,
	          routes = _props.routes;
	
	      var bookingProperty = location.state && location.state.property != '' ? location.state.property : null;
	
	      return _react2.default.createElement(
	         "div",
	         null,
	         _react2.default.createElement(_header2.default, { hideEnquire: true, theme: "trans", menu: this.props.data.prismicMainNavigation.data }),
	         _react2.default.createElement(
	            BgWrapper,
	            null,
	            _react2.default.createElement(
	               EnquiryWrapper,
	               null,
	               _react2.default.createElement("div", { className: "close-button", onClick: function onClick() {
	                     return _this2.props.history.goBack();
	                  } }),
	               _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Book an Appointment"
	               ),
	               _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Register below to book an exclusive viewing. Nominate your preferred day and one of our team will get back to you shortly."
	               ),
	               _react2.default.createElement(_bookForm2.default, { square: true, property: bookingProperty, utm: this.props.utm })
	            )
	         )
	      );
	   };
	
	   return Enquiry;
	}(_react2.default.Component);
	
	var BgWrapper = _styledComponents2.default.div(_templateObject, vars.padding.inner, _functions.below.tablet(_templateObject2, vars.padding.tabInner), _functions.below.mobile(_templateObject3, vars.padding.mobInner));
	
	var EnquiryWrapper = _styledComponents2.default.div(_templateObject4, vars.padding.inner * 2, vars.padding.inner, _functions.below.tablet(_templateObject5, vars.padding.tabInner), _functions.below.mobile(_templateObject6, vars.padding.tabInner, vars.padding.mobInner), _functions.below.tablet(_templateObject7, vars.padding.tabInner), _functions.below.mobile(_templateObject7, vars.padding.mobInner), vars.colors.inactiveColor);
	
	exports.default = Enquiry;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-booking-js-52ea8af6c3ae7be945f6.js